<template>
  <div class="parking__legend-container">
      <div class="parking__legend-label">
        <translated-text-component translation="nav_parking_legend_label" />
      </div>
      <div class="parking__legend-list">
        <div class="parking__legend-item">
          <div class="parking__legend-line --big"></div>
          <div class="parking__legend-value">100%</div>
        </div>
        <div class="parking__legend-item">
          <div class="parking__legend-line --middle"></div>
          <div class="parking__legend-value">80%</div>
        </div>
        <div class="parking__legend-item">
          <div class="parking__legend-line --small"></div>
          <div class="parking__legend-value">50%</div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref, computed, watch } from 'vue';
import store                                   from '@/store';

const ParkingGroupLegend: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    parentState: {
      type: Boolean,
      default: true,
      name: 'parentState',
    },
  },
  name: 'ParkingGroupLegend',
  setup() {

    return {};
  },
});
export default ParkingGroupLegend;
</script>

<style scoped lang="scss">
.parking__legend {
  &-container {
    font-size: rem(13px);
    display: flex;
    align-items: center;
    margin-right: 30px;
    color: $main-font-color;
    
    @include width-from($mobile) {
    }
  }

  &-label {
    margin-right: 10px;
  }

  &-list {
    padding: 13px 0;
  }

  &-item {
    display: flex;
    align-items: flex-start;

    &:first-child {
      .parking__legend-value {
        display: none;
      }
    }
  }

  &-line {
    width: 4px;
    height: 32px;
    margin-right: 3px;
    background-color: grey;

    &.--small {
      background-color: #28972f;
    }
    &.--middle {
      background-color: #FFE11B;
    }
    &.--big {
      background-color: #de3e3e;
    }
  }

  &-value {
    font-size: rem(12px);
    font-weight: 600;
    margin-top: -17%;
    color: $main-font-color;
  }
}
</style>
